declare const jQuery

export const bannerSliderScroll = (): void => {
  const topBannerWrapper = document.querySelector('.js-bannerSlider-main') as unknown as HTMLElement

  const bodyElement = document.querySelector('body') as unknown as HTMLElement

  if (!topBannerWrapper || !bodyElement) {
    return
  }

  const allScrollLinks = topBannerWrapper.querySelectorAll('.js-bannerSlider-scrollButton') as unknown as HTMLElement[]

  allScrollLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault()

      const offset = topBannerWrapper.offsetHeight

      jQuery('html, body').animate({
        scrollTop: offset
      }, 500)
    })
  })
}
